import React from 'react'
import { NavLink } from 'react-router-dom'
import '../styles/project.css'
import Header2 from '../components/Header2'

const arr = [
    {
        title: "Dom w Kustrzycach",
        size: "130 m2",
        year: "2019",
        text: "Projekt domu jednorodzinnego w okolicach Zduńskiej Woli. Wnętrza, które mają za zadanie wyeksponować piękno okolicy poprzez duże otwory okienne i neutralne, naturalne barwy. Oryginalne sofy w kolorze miodowym są akcentem przełamującym klimat wnętrza. Miedziane dodatki i czarne oświetlenie utrzymują projekt w najnowszych trendach. Otwarta kuchnia na salon i dyskretnie oddzielony gabinet tworzą dużą rodzinną przestrzeń dla domowników. ",
        img: "DWK"
    },
    {
        title: "Dom pod Łodzią",
        size: "120 m2",
        year: "2019",
        text: "Projekt domu jednorodzinnego w okolicach Łodzi. Dom/pracownia miał posiadać wnętrza, które będą eksponować prace właścicieli i uczniów. Minimalistyczne, surowe, monochromatyczne, przełamane drewnem przestrzenie mają być tylko tłem dla barwnych mieszkańców. ",
        img: "DPL"
    },
    {
        title: "Dom w Zduńskiej Woli",
        size: "120 m2",
        year: "2020",
        text: "Projekt domu jednorodzinnego w okolicach Zduńskiej Woli. Wnętrza w stylu loftowym w których dominuje drewno, beton, cegła oraz czarne dodatki. Aby ocieplić przestrzeń zastosowane zostały kolorowe meble tapicerowane. Personalizowane koszulki w oprawach to znak rozpoznawczy właściciela, który jest piłkarzem. ",
        img: "DWZ"
    },
    {
        title: "Dom w Holendrach",
        size: "120 m2",
        year: "2020",
        text: "Projekt domu jednorodzinnego w okolicach Zduńskiej Woli. Zastosowany tu został wspólny materiał, kolor, coś co przeplatając się przez wszystkie strefy, sprawia, że przestrzeń jest spójna. ",
        img: "DH"
    },
    {
        title: "Dom w Zduńskiej Woli",
        size: "130 m2",
        year: "2019",
        text: "Projekt domu jednorodzinnego w Zduńskiej Woli. Wnętrza nowoczesne w których przeważa naturalna szarość betonu i ciepło drewna, a kropką nad i są czarne dodatki.",
        img: "DZW"
    },
    {
        title: "Mieszkanie w Zduńskiej Woli",
        size: "",
        year: "2019",
        text: "Projekt mieszkania w Zduńskiej Woli. Połącznie nowoczesności z klasyką. Meble inwestorów z wcześniejszego mieszkania oraz pamiątki rodzinne zostały idealne wkomponowane w nowe wnętrza. ",
        img: "MZW"
    },
    {
        title: "Mieszkanie w Warszawie",
        size: "36 m2",
        year: "2019",
        text: "Projekt mieszkania w Warszawie. Niewielkie wnętrze dla studentki wymagało przemyślanych rozwiązań, które połączą ergonomię z estetyką . Właścicielka jest fanką mocnych kolorów i paryskich wnętrz co zostało uwzględnione w projekcie.",
        img: "MSW"
    },
    {
        title: "Mieszkanie w Zduńskiej Woli",
        size: "",
        year: "2019",
        text: "Projekt mieszkania w Zduńskiej Woli. Wspólnie z inwestorami postanowiliśmy wyburzyć jedną ze ścian co otworzyło nam przestrzeń kuchni na wąski korytarz. Zmiana części mebli, drzwi, paneli i uzyskaliśmy efekt wow, ale w spokojnej naturalnej wersji. W tym przypadku jest to wnętrze idealnie dobrane do jego właścicieli. Można stwierdzić, że skrojone na miarę. ",
        img: "MZ"
    },
    {
        title: "Pokoje dziecięce",
        size: "",
        year: "",
        text: "",
        img: "PD"
    },
    {
        title: "Kuchnia Płock",
        size: "",
        year: "",
        text: "",
        img: "KP"
    },
    {
        title: "Aparthotel Warszawa",
        size: "",
        year: "2019",
        text: "",
        img: "AHW"
    },
    {
        title: "Łazienki",
        size: "",
        year: "",
        text: "",
        img: "LAZ"
    }
]



const ProjectPage = (props) => {
    const { id } = props.match.params

    return (
        <div>
            <Header2 />
            <div className="container project">
                <NavLink to="/"><i class="back-btn fas fa-angle-double-left"></i></NavLink>
                <h1>{arr[id].title}</h1>
                <p><strong>{arr[id].year}</strong> <br></br> {arr[id].size}</p>
                <p className="text-justify">{arr[id].text}</p>
                <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="4"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img src={require(`../images/${arr[id].img}_01.jpg`)} class="d-block w-100" alt="obraz" />
                        </div>
                        <div class="carousel-item">
                            <img src={require(`../images/${arr[id].img}_02.jpg`)} class="d-block w-100" alt="obraz" />
                        </div>
                        <div class="carousel-item">
                            <img src={require(`../images/${arr[id].img}_03.jpg`)} class="d-block w-100" alt="obraz" />
                        </div>
                        <div class="carousel-item">
                            <img src={require(`../images/${arr[id].img}_04.jpg`)} class="d-block w-100" alt="obraz" />
                        </div>
                        <div class="carousel-item">
                            <img src={require(`../images/${arr[id].img}_05.jpg`)} class="d-block w-100" alt="obraz" />
                        </div>
                    </div>
                    <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="sr-only">Previous</span>
                    </a>
                    <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="sr-only">Next</span>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default ProjectPage;